const numberFormatter = new Intl.NumberFormat("en-NZ");

export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) return "0";
  return numberFormatter.format(value);
}

const compactFormatter = new Intl.NumberFormat("en-NZ", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatCompact(value: number): string {
  if (!Number.isFinite(value)) return "0";
  return compactFormatter.format(value);
}

export function formatPercentage(value: number): string {
  if (!Number.isFinite(value)) return "0%";
  return `${value.toFixed(1)}%`;
}

const shortDateFormatter = new Intl.DateTimeFormat("en-NZ", {
  day: "numeric",
  month: "short",
  timeZone: "UTC",
});

export function formatShortDate(isoString: string): string {
  try {
    return shortDateFormatter.format(new Date(isoString + "T00:00:00Z"));
  } catch {
    return isoString;
  }
}
